import React from 'react';
import { Check, Users, Heart } from 'lucide-react';
export function Results() {
  return <section className="py-20 bg-white text-[#3D2B1F]" data-id="element-104">
      <div className="max-w-6xl mx-auto px-6" data-id="element-105">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-106">
          {/* Results List */}
          <div data-id="element-107">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8" data-id="element-108">
              Lo que vas a lograr en 7 días
            </h2>
            <ul className="space-y-6" data-id="element-109">
              {['Bajar tu nivel de reactividad (menos gritos)', 'Tener un “Plan Rojo” para días imposibles', 'Recuperar pequeñas islas de control', 'Sentirte más estable aunque el entorno siga caótico', 'Saber exactamente qué hacer cuando “ya no puedes”'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-110">
                  <div className="w-6 h-6 rounded-full bg-[#E8856C]/20 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-111">
                    <Check className="w-4 h-4 text-[#E8856C]" data-id="element-112" />
                  </div>
                  <span className="text-lg" data-id="element-113">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Audience Fit */}
          <div className="bg-[#FFF8F0] p-8 md:p-10 rounded-3xl border border-[#F5E6D3]" data-id="element-114">
            <h3 className="font-serif text-2xl font-bold mb-6 flex items-center gap-3" data-id="element-115">
              <Users className="w-6 h-6 text-[#E8856C]" data-id="element-116" />
              ¿Para quién es?
            </h3>
            <p className="mb-6 text-[#3D2B1F]/80" data-id="element-117">
              Para mamás con niños de 0–5 años que:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-118">
              <li className="flex items-center gap-3" data-id="element-119">
                <Heart className="w-4 h-4 text-[#E8856C] fill-current" data-id="element-120" />
                <span data-id="element-121">Están cansadas de intentarlo todo y fallar</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-122">
                <Heart className="w-4 h-4 text-[#E8856C] fill-current" data-id="element-123" />
                <span data-id="element-124">Sienten que cargan solas con la carga mental</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-125">
                <Heart className="w-4 h-4 text-[#E8856C] fill-current" data-id="element-126" />
                <span data-id="element-127">No quieren teoría: quieren un plan real</span>
              </li>
            </ul>

            <div className="pt-6 border-t border-[#3D2B1F]/10" data-id="element-128">
              <h4 className="font-bold text-sm uppercase tracking-wider mb-2 text-[#3D2B1F]/60" data-id="element-129">
                ¿Para quién NO es?
              </h4>
              <p className="text-sm text-[#3D2B1F]/80" data-id="element-130">
                Para quien busca terapia clínica o promesas médicas. Esta guía
                es educación práctica y herramientas de organización emocional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}